import {connect} from 'react-redux';
import {size} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {pageSize} from '/constant/data.constant';
import {
  PAGE_NUMBER_FIELD_NAME,
  PAGE_SIZE_FIELD_NAME,
} from '/enum/apiFields.enum';
import {myTeams} from '/redux/action/report.action';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  hasReportData,
  reportData,
  reportIsLoadingStateValue,
  reportMeta,
} from '/redux/selector/report.selector';
import {calculatePageNumber} from '/util/requestParams.util';
import {withProps} from '/util/selector.util';

import {ModalFilter} from './ModalPopoverFilter';

export default connect(
  createStructuredSelector({
    reportIsLoading: reportIsLoadingStateValue,
    hasReportData,
    reportData,
    reportMeta,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestAchievedRank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
  }),
  dispatch => ({
    fetchReport: ({
      reportName,
      reportParams,
      appendData,
      rank,
      period,
      fibc,
      frontline,
      fqvMin,
      fqvMax,
      newClientsAbove,
      newClientsBelow,
      qualifiedClientsAbove,
      qualifiedClientsBelow,
      newCoachesAbove,
      newCoachesBelow,
      closeToNextRank,
    }: any) => {
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        myTeams({
          reportName,
          reportParams,
          appendData,
          rank,
          period,
          fibc,
          frontline,
          fqvMin,
          fqvMax,
          newClientsAbove,
          newClientsBelow,
          qualifiedClientsAbove,
          qualifiedClientsBelow,
          newCoachesAbove,
          newCoachesBelow,
          closeToNextRank,
        }),
      );
    },
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    fetchReportData: ({
      rank,
      period,
      fibc,
      frontline,
      fqvMin,
      fqvMax,
      newClientsAbove,
      newClientsBelow,
      qualifiedClientsAbove,
      qualifiedClientsBelow,
      newCoachesAbove,
      newCoachesBelow,
      closeToNextRank,
    }: any) => {
      const {reportName, reportParams: [firstParam = {}, ...restParams] = []} =
        ownProps;
      const {reportIsLoading} = stateProps;
      if (!reportIsLoading) {
        return dispatchProps.fetchReport({
          reportName,
          reportParams: [
            {
              ...firstParam,
              [PAGE_SIZE_FIELD_NAME]: pageSize,
              [PAGE_NUMBER_FIELD_NAME]: 1,
            },
            ...restParams,
          ],
          appendData: false,
          rank,
          period,
          fibc,
          frontline,
          fqvMin,
          fqvMax,
          newClientsAbove,
          newClientsBelow,
          qualifiedClientsAbove,
          qualifiedClientsBelow,
          newCoachesAbove,
          newCoachesBelow,
          closeToNextRank,
        });
      }
    },
    fetchMoreReport: ({
      rank,
      period,
      fibc,
      frontline,
      fqvMin,
      fqvMax,
      newClientsAbove,
      newClientsBelow,
      qualifiedClientsAbove,
      qualifiedClientsBelow,
      newCoachesAbove,
      newCoachesBelow,
      closeToNextRank,
    }: any) => {
      const {reportIsLoading, reportMeta} = stateProps;

      const {isEndReached, currentPage = 1} = reportMeta || {};

      const {reportName, reportParams: [firstParam = {}, ...restParams] = []} =
        ownProps;

      if (!reportIsLoading && !isEndReached) {
        const numberOfRecords = size(stateProps.reportData);
        const total = reportMeta?.page?.total ?? 0;
        const nextPageNumber = calculatePageNumber({
          numberOfRecords,
          pageSize,
          total,
        });
        if (!nextPageNumber) return;
        if (nextPageNumber <= currentPage) return;

        return dispatchProps.fetchReport({
          reportName,
          reportParams: [
            {
              ...firstParam,
              [PAGE_SIZE_FIELD_NAME]: pageSize,
              [PAGE_NUMBER_FIELD_NAME]: nextPageNumber,
            },
            ...restParams,
          ],
          appendData: true,
          rank,
          period,
          fibc,
          frontline,
          fqvMin,
          fqvMax,
          newClientsAbove,
          newClientsBelow,
          qualifiedClientsAbove,
          qualifiedClientsBelow,
          newCoachesAbove,
          newCoachesBelow,
          closeToNextRank,
        });
      }
    },
  }),
)(ModalFilter);
